export const Cache = {
  keyTeams: 'Teams1aFEB',
  ttl: 60 * 60 * 1000,
  setWithExpiry: (key, value) => {
    const now = new Date()
    const item = {
      value: value,
      expiry: now.getTime() + Cache.ttl,
    }
    localStorage.setItem(key, JSON.stringify(item))
  },

  getWithExpiry: (key) => {
    const itemStr = localStorage.getItem(key)
    if (!itemStr) {
      return null
    }
    const item = JSON.parse(itemStr)
    const now = new Date()
    if (now.getTime() > item.expiry) {
      localStorage.removeItem(key)
      return null
    }
    return item.value
  }
}